// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__iXvEz","header":"styles_header__3Znjg","table":"styles_table__f-x7F"};